export const getColumnWidthsSettingsKey = (location: string) =>
  `COLUMN_WIDTHS_${location.substring(1).toUpperCase()}`;
